import {
    GetAudioFileErrorPayload,
    GetAudioFileSuccessPayload,
    GetVoicemailBoxesErrorPayLoad,
    GetVoicemailBoxesSuccessPayload,
    GetVoiceMailsErrorPayLoad,
    GetVoiceMailsSuccessPayload,
    MoveToTrashErrorPayLoad,
    SetHeardByVoicEmailIdErrorPayLoad,
    VoiceMailUrlPayloadType,
} from "../interfaces/voiceMail"

import {
    GetAudioFileError,
    GetAudioFileRequest,
    GetAudioFileSuccess,
    GetVoiceMailBoxesError,
    GetVoiceMailBoxesRequest,
    GetVoiceMailBoxesSuccess,
    getVoiceMailsError,
    getVoiceMailsRequest,
    getVoiceMailsSuccess,
    GetVoiceMailUrlError,
    GetVoiceMailUrlRequest,
    GetVoiceMailUrlSuccess,
    MoveToTrashError,
    MoveToTrashRequest,
    MoveToTrashSuccess,
    PostVoiceMailUrlError,
    PostVoiceMailUrlRequest,
    PostVoiceMailUrlSuccess,
    setHeardByVoicEmailIdError,
    setHeardByVoicEmailIdRequest,
    setHeardByVoicEmailIdSuccess
} from "../types/voiceMail/actionTypes"

import { Types } from "../types"
import { VoiceMailOperationsRequest, voiceMailRequest } from "../types/voiceMail/apiRequestTypes"
import { ErrorPayLoad } from "../types/common/commonTypes"

//get********************************************************************************************************************************************** */
export const getVoiceMailsRequestAction = (payload: voiceMailRequest): getVoiceMailsRequest => ({
    type: Types.GET_VOICE_MAIL_REQUEST,
    payload
})

export const getVoiceMailsSuccessAction = (payload: GetVoiceMailsSuccessPayload): getVoiceMailsSuccess => ({
    type: Types.GET_VOICE_MAIL_SUCCESS,
    payload
})

export const getVoiceMailsErrorAction = (payload: GetVoiceMailsErrorPayLoad): getVoiceMailsError => ({
    type: Types.GET_VOICE_MAIL_ERROR,
    payload
})

//Delete heared************************************************************************************************************************************** */
export const setHeardByVoicemailIdRequestAction = (payload: VoiceMailOperationsRequest): setHeardByVoicEmailIdRequest => ({
    type: Types.SET_HEARD_BY_VOICE_EMAIL_ID_REQUEST,
    payload
})

export const setHeardByVoicemailIdSuccessAction = (): setHeardByVoicEmailIdSuccess => ({
    type: Types.SET_HEARD_BY_VOICE_EMAIL_ID_SUCCESS,
})

export const setHeardByVoicemailIdErrorAction = (payload: SetHeardByVoicEmailIdErrorPayLoad): setHeardByVoicEmailIdError => ({
    type: Types.SET_HEARD_BY_VOICE_EMAIL_ID_ERROR,
    payload
})

// //MoveToTrash************************************************************************************************************************************* */
export const moveToTrashRequestAction = (payload: VoiceMailOperationsRequest): MoveToTrashRequest => ({
    type: Types.MOVE_TO_TRASH_VOICE_EMAIL_REQUEST,
    payload
})
export const moveToTrashSuccessAction = (): MoveToTrashSuccess => ({
    type: Types.MOVE_TO_TRASH_VOICE_EMAIL_SUCCESS,
})
export const moveToTrashErrorAction = (payload: MoveToTrashErrorPayLoad): MoveToTrashError => ({
    type: Types.MOVE_TO_TRASH_VOICE_EMAIL_ERROR,
    payload
})

// //************************************************************************************************************************************************** */

export const getAudioFileRequestAction = (payload: VoiceMailOperationsRequest): GetAudioFileRequest => ({
    type: Types.GET_AUDIO_FILE_VOICE_MAIL_REQUEST,
    payload
})
export const getAudioFileSuccessAction = (payload: GetAudioFileSuccessPayload): GetAudioFileSuccess => ({
    type: Types.GET_AUDIO_FILE_VOICE_MAIL_SUCCESS,
    payload
})
export const getAudioFileErrorAction = (payload: GetAudioFileErrorPayload): GetAudioFileError => ({
    type: Types.GET_AUDIO_FILE_VOICE_MAIL_ERROR,
    payload
})
//*************************************************************************************************************************************************** */

export const getVoiceMailBoxesRequestAction = (): GetVoiceMailBoxesRequest => ({
    type: Types.GET_VOICE_MAIL_BOX_REQUEST,
})
export const getVoiceMailBoxesSuccessAction = (payload: GetVoicemailBoxesSuccessPayload): GetVoiceMailBoxesSuccess => ({
    type: Types.GET_VOICE_MAIL_BOX_SUCCESS,
    payload
})
export const getVoiceMailBoxesErrorAction = (payload: GetVoicemailBoxesErrorPayLoad): GetVoiceMailBoxesError => ({
    type: Types.GET_VOICE_MAIL_BOX_ERROR,
    payload
})


export const GetVoiceMailUrlRequestAction = (payload: string): GetVoiceMailUrlRequest => ({
    type: Types.GET_LINE_VOICE_MAIL_URL_REQUEST,
    payload
})
export const GetVoiceMailUrlSuccessAction = (payload: any): GetVoiceMailUrlSuccess => ({
    type: Types.GET_LINE_VOICE_MAIL_URL_SUCCESS,
    payload
})
export const GetVoiceMailUrlErrorAction = (payload: ErrorPayLoad): GetVoiceMailUrlError => ({
    type: Types.GET_LINE_VOICE_MAIL_URL_ERROR,
    payload
})



export const PostVoiceMailUrlRequestAction = (payload: VoiceMailUrlPayloadType): PostVoiceMailUrlRequest => ({
    type: Types.POST_LINE_VOICE_MAIL_URL_REQUEST,
    payload
})
export const PostVoiceMailUrlSuccessAction = (payload: any): PostVoiceMailUrlSuccess => ({
    type: Types.POST_LINE_VOICE_MAIL_URL_SUCCESS,
    payload
})
export const PostVoiceMailUrlErrorAction = (payload: ErrorPayLoad): PostVoiceMailUrlError => ({
    type: Types.POST_LINE_VOICE_MAIL_URL_ERROR,
    payload
})
